import styled, { css } from 'styled-components';

export const ContainerStyled = styled.div`
  overflow: hidden;
  isolation: isolate;
  position: relative;

  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const WrapperStyled = styled.div`
  scrollbar-gutter: stable;

  flex: 1;
  gap: 16px;
  display: flex;
  flex-direction: column;

  ${({ isCovered }: { isCovered: boolean }) => {
    return isCovered
      ? css`
          overflow: hidden;
        `
      : css`
          overflow: auto;
        `;
  }}
`;
